var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFunding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "3 0 100 96",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "02") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1,
    d: "M64.2,51.7A25.2,25.2,0,1,0,39,26.6,25.2,25.2,0,0,0,64.2,51.7Zm0-46.3A21.2,21.2,0,1,1,43,26.6,21.2,21.2,0,0,1,64.2,5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1,
    d: "M64.2,34.7a3.1,3.1,0,0,1-3.1-3.1,2,2,0,0,0-4,0A7,7,0,0,0,62,38.3V40a2,2,0,0,0,4,0V38.4a7,7,0,0,0-1.8-13.8,3.1,3.1,0,0,1,0-6.2,3,3,0,0,1,3,3.1,2,2,0,0,0,4,0A7,7,0,0,0,66,14.7V14a2,2,0,0,0-4,0v.8a7.1,7.1,0,0,0,2.2,13.8,2.9,2.9,0,0,1,3,3A3,3,0,0,1,64.2,34.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.6, 0) scale(1.2,1)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1,
    d: "M93.2,59.3v-.2a7,7,0,0,0-4.8-2.6A7.3,7.3,0,0,0,83,58.1L70,68.6a15.2,15.2,0,0,1-8.9,3.3l-9.8.3a.8.8,0,0,1-.9-.4l-1.1-1.9a.8.8,0,0,1-.1-.9,1.1,1.1,0,0,1,.8-.6l10.1-1.9a7.2,7.2,0,0,0,5.7-7.8,7.1,7.1,0,0,0-7.3-6.2l-13.6-.6c-5.4-.2-10,.9-15.5,3.5l-7,3.2A6.2,6.2,0,0,0,17,55H9.2A6.5,6.5,0,0,0,3,61.4V89.6A6.5,6.5,0,0,0,9.2,96H17c3.3,0,6-3.1,6-6.4v-.9l7.4-1.4a28.9,28.9,0,0,1,6.6-.4l20.6,1A30.1,30.1,0,0,0,78,81L92.3,69.1a7.2,7.2,0,0,0,1-9.8ZM19,90a2,2,0,0,1-2,2H9a2,2,0,0,1-2-2V61a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2ZM89.7,66.1,75.5,77.9a26.6,26.6,0,0,1-17.7,6l-20.6-1a35.9,35.9,0,0,0-7.4.5L23,84.6V62.9L31.2,59a28.1,28.1,0,0,1,13.6-3.1l13.6.6h.2a3.1,3.1,0,0,1,3.2,2.6,3.1,3.1,0,0,1-2.5,3.5L49.2,64.5a4.9,4.9,0,0,0-3.6,2.8,5,5,0,0,0,.2,4.6l1.1,1.9a5,5,0,0,0,4.5,2.4l9.8-.3a18.7,18.7,0,0,0,11.3-4.2l13-10.5a3,3,0,0,1,2.4-.7A3.6,3.6,0,0,1,90,61.6h0c0,.1.1.1.1.2A3,3,0,0,1,89.7,66.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunding);
export default __webpack_public_path__ + "static/media/funding.c2ea04b6d8530a079fb4304264e561d1.svg";
export { ForwardRef as ReactComponent };